import { Flex } from "antd";
import { Navigate } from "react-router-dom";
import { useCustomer } from "../hooks/auth";

export const Unauthorized = () => {
    const isCustomer = useCustomer();
    if (isCustomer) {
        return <Navigate to="/account-home" replace />;
    }
    return (
        <Flex justify="center" align="middle" style={{ minHeight: '80vh' }} vertical>
            <div className="text-center">
                <h1>Unauthorized</h1>
                <p>You are not authorized to view this page.</p>
            </div>
        </Flex>
    );
}

export const NotFound = () => {
    return (
        <Flex justify="center" align="middle" style={{ minHeight: '80vh' }} vertical>
            <div className="text-center">
                <h1>Not Found</h1>
                <p>Page not found.</p>
            </div>
        </Flex>
    );
}